module.exports = __webpack_public_path__ + "img/TBWTTNL_choice.66cc9d7e.jpg";